import { Locales, PluralCategory } from '@griply/types';

const SLAVIC_PLURAL_LOCALES: Locales[] = [Locales.PlPL];

// Polish splits the plural: 2-4 take a distinct form from 5+, and the teens follow 5+.
const getSlavicCategory = (count: number) => {
  if (count === 1) {
    return PluralCategory.One;
  }

  const lastTwoDigits = count % 100;
  if (lastTwoDigits >= 12 && lastTwoDigits <= 14) {
    return PluralCategory.Many;
  }

  const lastDigit = count % 10;
  return lastDigit >= 2 && lastDigit <= 4
    ? PluralCategory.Few
    : PluralCategory.Many;
};

export const getPluralCategory = (count: number, language: Locales) => {
  if (SLAVIC_PLURAL_LOCALES.includes(language)) {
    return getSlavicCategory(count);
  }

  return count === 1 ? PluralCategory.One : PluralCategory.Other;
};
